var map = {
	"./Airplane.mp3": 49570,
	"./Almond.mp3": 22753,
	"./Ankle.mp3": 97513,
	"./Apple.mp3": 41680,
	"./Apron.mp3": 25540,
	"./Arm.mp3": 93270,
	"./Art.mp3": 85411,
	"./Baby.mp3": 19892,
	"./Bag.mp3": 50730,
	"./Ball.mp3": 6483,
	"./Balloon.mp3": 81433,
	"./Bathroom.mp3": 68370,
	"./Bear.mp3": 34026,
	"./Bed.mp3": 76449,
	"./Bee.mp3": 83676,
	"./Belt.mp3": 25423,
	"./Bench.mp3": 42954,
	"./Bicycle.mp3": 47927,
	"./Bird.mp3": 98813,
	"./Boat.mp3": 63810,
	"./Bone.mp3": 83978,
	"./Book.mp3": 80659,
	"./Bottle.mp3": 9856,
	"./Bowl.mp3": 81832,
	"./Box.mp3": 72863,
	"./Bracelet.mp3": 60332,
	"./Brain.mp3": 54924,
	"./Bread.mp3": 76058,
	"./Broom.mp3": 92603,
	"./Bucket.mp3": 85738,
	"./Cake.mp3": 12,
	"./Candy.mp3": 61119,
	"./Car.mp3": 43770,
	"./Carrot.mp3": 9169,
	"./Castle.mp3": 9820,
	"./Cat.mp3": 87524,
	"./Chair.mp3": 28579,
	"./Cheese.mp3": 68843,
	"./Cherry.mp3": 37091,
	"./Chicken.mp3": 20721,
	"./Chocolate.mp3": 84238,
	"./Clock.mp3": 11730,
	"./Coffee.mp3": 67364,
	"./Coin.mp3": 55131,
	"./Cold.mp3": 30350,
	"./Cookie.mp3": 66946,
	"./Couch.mp3": 82746,
	"./Cow.mp3": 66009,
	"./Doctor.mp3": 65565,
	"./Dog.mp3": 91094,
	"./Doll.mp3": 47503,
	"./Door.mp3": 18384,
	"./Dress.mp3": 69421,
	"./Duck.mp3": 7055,
	"./Earring.mp3": 47326,
	"./Egg.mp3": 90235,
	"./Eight.mp3": 90365,
	"./Eye.mp3": 10875,
	"./Face.mp3": 55799,
	"./Farm.mp3": 94116,
	"./Finger.mp3": 52271,
	"./Fire.mp3": 65092,
	"./Fish.mp3": 382,
	"./Five.mp3": 17376,
	"./Flour.mp3": 84796,
	"./Flower.mp3": 72761,
	"./Fork.mp3": 1948,
	"./Four.mp3": 36660,
	"./Fruit.mp3": 73006,
	"./Garlic.mp3": 6746,
	"./Glass.mp3": 40340,
	"./Glove.mp3": 90183,
	"./Grape.mp3": 25141,
	"./Green.mp3": 31717,
	"./Hand.mp3": 31143,
	"./Hat.mp3": 78219,
	"./Head.mp3": 25230,
	"./Health.mp3": 91074,
	"./Heart.mp3": 59332,
	"./Heavy.mp3": 67561,
	"./Help.mp3": 62477,
	"./History.mp3": 70104,
	"./Hook.mp3": 27841,
	"./Horse.mp3": 55195,
	"./Hose.mp3": 93987,
	"./Hospital.mp3": 99666,
	"./Hot.mp3": 33941,
	"./House.mp3": 39700,
	"./Husband.mp3": 13813,
	"./Jug.mp3": 13158,
	"./Key.mp3": 99425,
	"./Kite.mp3": 87693,
	"./Knife.mp3": 19959,
	"./Large.mp3": 80977,
	"./Left.mp3": 1671,
	"./Leg.mp3": 748,
	"./Lemon.mp3": 21821,
	"./Lentil.mp3": 94028,
	"./Lion.mp3": 79046,
	"./Long.mp3": 13442,
	"./Luggage.mp3": 6864,
	"./Man.mp3": 18428,
	"./Mattress.mp3": 65049,
	"./Milk.mp3": 77605,
	"./Mirror.mp3": 26909,
	"./Money.mp3": 85388,
	"./Monkey.mp3": 8463,
	"./Month.mp3": 40922,
	"./Morning.mp3": 11808,
	"./Mouse.mp3": 83437,
	"./Mouth.mp3": 18501,
	"./Mushroom.mp3": 53329,
	"./Name.mp3": 41685,
	"./Nest.mp3": 20158,
	"./Nine.mp3": 40656,
	"./North.mp3": 95533,
	"./Nose.mp3": 7941,
	"./Oat.mp3": 27792,
	"./Office.mp3": 15240,
	"./Oil.mp3": 47984,
	"./One.mp3": 70772,
	"./Onion.mp3": 71127,
	"./Oven.mp3": 77802,
	"./Owl.mp3": 3130,
	"./Oxygen.mp3": 24296,
	"./Pants.mp3": 36538,
	"./Pear.mp3": 80168,
	"./Pen.mp3": 87109,
	"./Pencil.mp3": 35035,
	"./Pepper.mp3": 79996,
	"./Pig.mp3": 83316,
	"./Pink.mp3": 6692,
	"./Plum.mp3": 41742,
	"./Pool.mp3": 36954,
	"./Popcorn.mp3": 16155,
	"./Purple.mp3": 6750,
	"./Rabbit.mp3": 46672,
	"./Rag.mp3": 29146,
	"./Red.mp3": 7313,
	"./Rice.mp3": 61395,
	"./Salt.mp3": 94512,
	"./Sandal.mp3": 97545,
	"./Scissors.mp3": 54261,
	"./Scooter.mp3": 98497,
	"./Seven.mp3": 63515,
	"./Shampoo.mp3": 27511,
	"./Sheep.mp3": 29241,
	"./Shirt.mp3": 41320,
	"./Shoe.mp3": 29773,
	"./Short.mp3": 91558,
	"./Shovel.mp3": 63905,
	"./Sister.mp3": 39948,
	"./Six.mp3": 67480,
	"./Skin.mp3": 29927,
	"./Small.mp3": 87097,
	"./Smile.mp3": 46932,
	"./Snake.mp3": 18912,
	"./Sock.mp3": 23400,
	"./Soup.mp3": 83585,
	"./South.mp3": 11092,
	"./Spinach.mp3": 73128,
	"./Spoon.mp3": 25955,
	"./Strawberry.mp3": 95855,
	"./Study.mp3": 94715,
	"./Table.mp3": 56148,
	"./Taco.mp3": 28399,
	"./Tea.mp3": 90442,
	"./Teacher.mp3": 86274,
	"./Ten.mp3": 15537,
	"./Three.mp3": 39456,
	"./Toaster.mp3": 95228,
	"./Tomato.mp3": 1126,
	"./Tree.mp3": 98376,
	"./Triangle.mp3": 11628,
	"./Truck.mp3": 55301,
	"./Two.mp3": 23878,
	"./Wallet.mp3": 81979,
	"./Want.mp3": 73426,
	"./Water.mp3": 77393,
	"./Watermelon.mp3": 44022,
	"./Wheel.mp3": 37785,
	"./White.mp3": 3243,
	"./Window.mp3": 99380,
	"./Yellow.mp3": 26552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43103;